"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-twelve/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSection66sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/about-twelve-1.svg" | "/Templates/Doccure/img/icons/about-twelve-2.svg" | "/Templates/Doccure/img/icons/about-twelve-3.svg" | "/Templates/Doccure/img/icons/about-twelve-4.svg" */
    src: string;
    /** Detected variants: "Quick Reporting" | "Affordable Pricing" | "Advanced Technology" | "Home Collection" */
    h30Text: ReactNode;
    /** Detected variants: "We follow strict ISO certified protocols to ensure safe." | "We offer transparent pricing with no hidden charges, ensuring complete" | "Get fast, accurate reports delivered digitally, ensuring timely insights" | "Our trained professionals collect samples from your home." */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-6 col-sm-6 d-flex" */
    className?: string;
    /** Detected variants: "about-item-twelve flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "about-icon" */
    div0ClassName2?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "about-img" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid img-two" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/about-twelve-5.png" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "mb-0" */
    p0ClassName?: string;
};
export type HomeTwelveAboutSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection66sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection66sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection66sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "about-img" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-img-one.jpg" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "about-img" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-img-two.jpg" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "" */
    sectionDiv0Div0Div0Div0Link0LinkDataFancybox?: string;
    /** Default: "#" */
    sectionDiv0Div0Div0Div0Link0LinkHref?: string;
    sectionDiv0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Play Video Play Video " */
    sectionDiv0Div0Div0Div0Link0Button0ButtonDataText?: string;
    sectionDiv0Div0Div0Div0Link0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Link0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Link0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "We Bring Healthcare Closer to you with" */
    sectionDiv0Div0Div1Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Professionalism & Care." */
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div0Div1Div0Div1ClassName?: string;
    /** Default: "shadow" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-shadow-img.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    aboutSection66s: AboutSection66sItem[];
    aboutSection66sItemWrapper?: (item: AboutSection66sItem, content: ReactNode) => ReactNode;
    aboutSection66sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSection66sImageVisible?: boolean;
    aboutSection66sImageRenderer?: (item: AboutSection66sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection66sH3Visible?: boolean;
    aboutSection66sH3Renderer?: (item: AboutSection66sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection66sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection66sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection66sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection66sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwelveAboutSectionGenerated: FC<HomeTwelveAboutSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "about-img",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-img-one.jpg",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt = "about-img",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/about/about-img-two.jpg",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div0Div0Link0Button0ButtonDataText = "Play Video Play Video ",
    sectionDiv0Div0Div0Div0Link0Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Link0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Link0Button0ButtonProps,
    sectionDiv0Div0Div0Div0Link0LinkDataFancybox = "",
    sectionDiv0Div0Div0Div0Link0LinkHref = "#",
    sectionDiv0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div1Div0Div0H20H2Text = "We Bring Healthcare Closer to you with",
    sectionDiv0Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0Div0H20H2Props,
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText = "Professionalism & Care.",
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionImageWithBasePath0ImageAlt = "shadow",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/about-shadow-img.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div1Div0Div1ClassName,
    aboutSection66s,
    aboutSection66sItemWrapper,
    aboutSection66sRenderer,
    aboutSection66sImageVisible,
    aboutSection66sImageRenderer,
    aboutSection66sH3Visible,
    aboutSection66sH3Renderer,
    aboutSection66sImageProps,
    aboutSection66sH3Props,
}) => {
    return (
        <>
            <section className="about-section-twelve section">
                <div className="container">
                    <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                        <div className="col-xl-6 col-lg-12">
                            <div className="about-img-twelve d-flex wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                                {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid img-two" {...(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                                ))}
                                {renderNode(sectionDiv0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Link0LinkHref} data-fancybox={sectionDiv0Div0Div0Div0Link0LinkDataFancybox} {...(sectionDiv0Div0Div0Div0Link0LinkProps ?? {})}>
                                        {renderNode(sectionDiv0Div0Div0Div0Link0Button0ButtonVisible, sectionDiv0Div0Div0Div0Link0Button0ButtonRenderer, (
                                            <button className="animate-button" data-text={sectionDiv0Div0Div0Div0Link0Button0ButtonDataText} {...(sectionDiv0Div0Div0Div0Link0Button0ButtonProps ?? {})}>
                                                <p className="button-text" />
                                                <span className="button-circle">
                                                    <i className="isax isax-play" />
                                                </span>
                                            </button>
                                        ))}
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-12">
                            <div className="about-content-tweleve wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                                <div className="section-header section-header-twelve">
                                    {renderNode(sectionDiv0Div0Div1Div0Div0H20H2Visible, sectionDiv0Div0Div1Div0Div0H20H2Renderer, (
                                        <h2 className="section-title" {...(sectionDiv0Div0Div1Div0Div0H20H2Props ?? {})}>
                                            {" "}
                                            {sectionDiv0Div0Div1Div0Div0H20H2Text}
                                            {" "}
                                            <span className="text-primary">{sectionDiv0Div0Div1Div0Div0H20Span0SpanText}</span>
                                        </h2>
                                    ))}
                                </div>
                                <div className={sectionDiv0Div0Div1Div0Div1ClassName ?? "row g-4"}>
                                    {renderCollectionNode(
                                        aboutSection66s,
                                        (item: AboutSection66sItem) => (
                                            <div className={item.className ?? "col-lg-6 col-sm-6 d-flex"} key={item.key}>
                                                <div className={item.div0ClassName ?? "about-item-twelve flex-fill"}>
                                                    <div className={item.div0ClassName2 ?? "about-icon"}>
                                                        {renderItemNode(aboutSection66sImageVisible, aboutSection66sImageRenderer, item, (
                                                            <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-one"} {...(typeof aboutSection66sImageProps === "function" ? aboutSection66sImageProps(item) : (aboutSection66sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </div>
                                                    {renderItemNode(aboutSection66sH3Visible, aboutSection66sH3Renderer, item, (
                                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof aboutSection66sH3Props === "function" ? aboutSection66sH3Props(item) : (aboutSection66sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                    ))}
                                                    <p className={item.p0ClassName ?? "mb-0"}>{item.p0Text}</p>
                                                    {renderItemNode(aboutSection66sImageVisible, aboutSection66sImageRenderer, item, (
                                                        <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/icons/about-twelve-5.png"} alt={item.imageWithBasePath0Alt ?? "about-img"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid img-two"} {...(typeof aboutSection66sImageProps === "function" ? aboutSection66sImageProps(item) : (aboutSection66sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </div>
                                            </div>
                                        ),
                                        aboutSection66sItemWrapper,
                                        aboutSection66sRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid about-shadow-img" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeTwelveAboutSectionGenerated;
